import { typedQueryClient, useTypedMutation } from "hooks";
import { AgreementsDashboardQueryKeys } from "modules/AgreementsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteAgreementMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async id => {
      await ApiInstance.post("/check_in/agreement/delete", { id });
    },
    onSuccess: deletedId => {
      const agreements = typedQueryClient.getQueryData(AgreementsDashboardQueryKeys.list);
      if (!agreements) return;

      const agreementIdx = agreements.findIndex(agreement => agreement.id === deletedId);
      if (agreementIdx === -1) return;

      typedQueryClient.setQueryData(AgreementsDashboardQueryKeys.list, agreements.toSpliced(agreementIdx, 1));
    }
  });
